import { Swiper, Navigation, Pagination, Drift } from '@hh/global.js'

class ProductMedia extends HTMLElement {
  constructor() {
    super()
    Swiper.use([Navigation]);
    Swiper.use([Pagination]);
    this.swiperSlider = new Swiper(this.querySelector('.js-slider'), {
      lazy: true,
      navigation: {
        nextEl: this.querySelector('.js-next'),
        prevEl: this.querySelector('.js-prev'),
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
    })

    this.swiperThumbnailSlider = new Swiper(this.querySelector('.js-thumbnail-slider'), {
      direction: 'vertical',
      slidesPerView: 5,
      spaceBetween: 20,
      navigation: {
        nextEl: this.querySelector('.js-thumbnail-next'),
        prevEl: this.querySelector('.js-thumbnail-prev'),
      },
    })

    this.swiperSlider.on('transitionEnd', () => {
      this.onSliderChange(this.swiperSlider.realIndex)
    })

    this.mainImages = this.querySelectorAll('.js-media-main-item')
    this.thumbImages = this.querySelectorAll('.js-media-thumbnail-item')

    this.addEventListener('SWATCH_IMAGES_CHANGE', this.onSwatchImagesChanged.bind(this))
    this.thumbImages.forEach(thumb => {
      thumb.addEventListener('click', () => {
        this.onThumbnailClicked(thumb)
      })
    })

    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

    this.mainImages.forEach(image => {
      if (!image.classList.contains('js-video-item') && isDesktop ) {
        this.imageDrift = new Drift (
          image,
          {
            paneContainer: this.querySelector('.js-media-item-zoom'),
            hoverBoundingBox: true,
            boundingBoxContainer: this.querySelector('.js-media-item-zoom-box'),
            zoomFactor: 3,
            onShow: () => this.onZoomShow(),
            onHide: () => this.onZoomHide()
          }
        )
      }
    })

    this.adjustZoomBox()
    window.addEventListener('resize', () => {
      this.adjustZoomBox()
    })

    if (this.activeThumbs.length > 5) {
      this.querySelector('.js-thumbnail-next').classList.remove('hidden')
      this.querySelector('.js-thumbnail-prev').classList.remove('hidden')
    } else {
      this.querySelector('.js-thumbnail-next').classList.add('hidden')
      this.querySelector('.js-thumbnail-prev').classList.add('hidden')
    }
  }

  onZoomHide () {
    this.querySelectorAll('.js-media-item-zoom, .js-media-item-zoom-box')
      .forEach(element => element.classList.add('disabled'))
  }

  onZoomShow () {
    this.querySelectorAll('.js-media-item-zoom, .js-media-item-zoom-box')
      .forEach(element => element.classList.remove('disabled'))
  }

  adjustZoomBox () {
    const target = this.querySelector('.js-media-item-zoom-box')
    const rect = target.getBoundingClientRect()

    target.style.setProperty('--hh-margin-top', `${0 - rect.top}px`)
    target.style.setProperty('--hh-margin-left', `${0 - rect.left}px`)
  }

  onSwatchImagesChanged (e) {
    if (!e.detail?.handle) return
    const handle = e.detail?.handle

    this.mainImages.forEach(imageTpl => {
      if (imageTpl.getAttribute('data-title-handle') === handle) {
        imageTpl.classList.remove('hidden')
      } else {
        imageTpl.classList.add('hidden')
      }
    })

    this.thumbImages.forEach(imageTpl => {
      if (imageTpl.getAttribute('data-title-handle') === handle) {
        imageTpl.classList.remove('hidden')
      } else {
        imageTpl.classList.add('hidden')
      }
    })

    this.swiperSlider.updateSlides()
    this.swiperThumbnailSlider.updateSlides()
    this.swiperSlider.slideTo(0)
  }

  onThumbnailClicked (thumbEl) {
    const activeIndex = this.activeThumbs.indexOf(thumbEl)
    if ((activeIndex > -1) && this.swiperSlider) this.swiperSlider.slideTo(activeIndex)
  }

  onSliderChange (index) {
    this.activeThumbs.forEach((thumb, thumbIndex) => {
      if (thumbIndex == index) {
        thumb.classList.add('active')
      } else {
        thumb.classList.remove('active')
      }
    })
  }

  get activeThumbs() {
    return Array.from(document.querySelectorAll('.js-media-thumbnail-item:not(.hidden)')) ?? []
  }
}

customElements.define('hh-product-media', ProductMedia)
